
import moment from 'moment/moment'
import { useEffect, useState } from 'react'
import { CircularProgressbar } from 'react-circular-progressbar'
import { Link } from 'react-router-dom'

import { useAppDispatch } from '../../../../store'
import { escalateAlert, getCareteam, ownAlert } from '../../../alerts/actions'
import * as Table from '../../../claim-history/simple-table'
import { useAlerts } from '../../../dashboard/queries/alerts'
import { NoDataPlaceHolder } from '../../../PatientFolder/behavioral/components'
import { ContextMenuButton } from '../../../shared/ContextMenu'
import { FriendlyDateTime } from '../../../shared/Date/friendly-date-time'
import { CircularProgress } from '../../../shared/NarusMaterial'
import * as Sidebar from '../components'

import { getMyStatus, alertsStatusesMap, DATETIME_FORMAT } from './utils'

import 'react-circular-progressbar/dist/styles.css'

export function Alerts (): JSX.Element {
  const alertsQuery = useAlerts()
  const alerts = alertsQuery?.data
  const loading = alertsQuery.isLoading

  const dispatch = useAppDispatch()
  const [ own, setOwn ] = useState<string[]>([])
  const [ currentTime, setCurrentTime ] = useState<string>(moment().clone().toISOString())

  const ownedFn = (id: string): void => {
    if (own.includes(id)) {
      return
    }
    ownAlert(id).then(() => {
      setOwn((prev) => [ ...prev, id ])
    }).catch((e) => {
      console.error(e)
    })
  }

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentTime(moment().clone().toISOString())
    }, 5000)
    return () => {
      clearInterval(interval)
    }
  }, [])

  if (loading && (!alerts || !alerts?.length)) {
    return (
      <>
        <Sidebar.Header
          link='/alerts'
          linkTitle='Alerts'
        >
          Alerts
        </Sidebar.Header>
        <Sidebar.Wrapper>
          <div className='flex flex-row justify-center mt-10'>
            <CircularProgress />
          </div>
        </Sidebar.Wrapper>
      </>
    )
  }

  return (
    <>
      <div className='h-full flex-1'>
        <Sidebar.Header
          link='/alerts'
          linkTitle='Alerts'
        >
          <span style={{ fontFamily: 'Roboto, sans-serif' }}>Alerts {alerts?.length ?? ''}</span>
        </Sidebar.Header>
        <Sidebar.Wrapper>
          <div className='h-full flex flex-col'>
            <Table.ContainerMeasureProvider>
              {(alerts?.length ?? 0) <= 0 && (
                <NoDataPlaceHolder
                  title='There are no Alerts to display'
                  className='bg-white mt-4 mx-3 rounded-xl'
                />
              )}
              <Sidebar.Cards>
                {alerts?.map(({
                  id,
                  patient_last_name: lastName,
                  patient_first_name: firstName,
                  client_name: clientName,
                  patient_id: patientId,
                  status,
                  meta,
                  title,
                  status_history: statusHistory,
                  created_at: createdAt
                }) => {
                  const isL5 = status === 'l5'
                  const { progress } = getMyStatus(statusHistory, status, currentTime)
                  const color = alertsStatusesMap[status]?.color
                  return (
                    <Sidebar.Card key={id}>
                      <Link
                        title='Open Patient Folder'
                        className='flex flex-row items-center justify-between overflow-hidden'
                        to={`/patient/${clientName}/${patientId}/assessment/standardsymptomsesas`}
                      >
                        <div className='flex flex-row items-center overflow-hidden'>
                          <CircularProgressbar
                            className='w-9 h-9'
                            value={isL5 ? 100 : progress ?? 0}
                            strokeWidth={10}
                            styles={{
                              path: {
                                stroke: color ?? alertsStatusesMap.l1.color
                              },
                              text: {
                                fill: color,
                                fontSize: '32px',
                                fontWeight: 'bold'
                              }
                            }}
                            text={status.toUpperCase()}
                          />
                          <div
                            style={{
                              marginLeft: '1rem',
                              flex: 1,
                              overflow: 'hidden',
                              display: 'flex',
                              flexDirection: 'column',
                              gap: '0.35rem'
                            }}
                          >
                            <span className='truncate font-semibold text-xs text-black tracking-wide'>{firstName} {lastName}</span>
                            <span className='truncate text-black'>{title}</span>
                            {createdAt && (
                              <span
                                className='text-xs text-[#7A879E]'
                                title={`Reported at ${moment(createdAt).format(DATETIME_FORMAT)}`}
                              >
                                <FriendlyDateTime datetime={createdAt} />
                              </span>
                            )}
                          </div>
                        </div>
                      </Link>
                      <div className='flex flex-1 gap-4 flex-col justify-between items-end h-full'>
                        <ContextMenuButton
                          actions={[{
                            id: 'own',
                            label: 'Own',
                            onClick: () => ownedFn(id)
                          },
                          ...(isL5
                            ? []
                            : [{
                              id: 'escalate',
                              label: 'Escalate',
                              onClick: async () => await escalateAlert(id)
                            }]
                          ),
                          {
                            id: 'show-care-team',
                            label: 'Care Team',
                            onClick: () => dispatch(getCareteam(meta.careTeam))
                          }
                          ]}
                          onClose={() => ({})}
                          direction='bottom-left'
                        />

                        <button
                          className='font-semibold pointer text-primary bg-opacity-10 py-0.5 px-2 rounded-md hover:bg-primary hover:bg-opacity-10'
                          data-test-id='alerts-own'
                          onClick={() => ownedFn(id)}
                        >
                          <span className='text-[14px]'>own</span>
                        </button>
                      </div>
                    </Sidebar.Card>
                  )
                })}
              </Sidebar.Cards>
            </Table.ContainerMeasureProvider>
          </div>
        </Sidebar.Wrapper>
      </div>
    </>
  )
}
